/**
 * Lavabolife Theme JavaScript
 * Vanilla JS - no frameworks
 */

(function() {
  'use strict';

  // ============================================
  // MOBILE NAVIGATION
  // ============================================
  function initMobileNav() {
    const toggle = document.getElementById('nav-toggle');
    const menu = document.getElementById('nav-menu');

    if (!toggle || !menu) return;

    toggle.addEventListener('click', function() {
      const isOpen = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen);
    });

    // Close menu on link click
    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        menu.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ============================================
  // ANNOUNCEMENT BAR DISMISS
  // ============================================
  function initAnnouncementBar() {
    const bar = document.getElementById('announcement-bar');
    const closeBtn = document.querySelector('.announcement-bar__close');

    if (!bar || !closeBtn) return;

    closeBtn.addEventListener('click', function() {
      bar.style.display = 'none';
      sessionStorage.setItem('announcement-dismissed', 'true');
    });

    // Check if already dismissed
    if (sessionStorage.getItem('announcement-dismissed') === 'true') {
      bar.style.display = 'none';
    }
  }

  // ============================================
  // PRODUCT GALLERY SLIDER
  // ============================================
  function initGallery() {
    const stage = document.getElementById('gallery-stage');
    const thumbsContainer = document.getElementById('gallery-thumbs');
    const prevBtn = document.getElementById('gallery-prev');
    const nextBtn = document.getElementById('gallery-next');
    const countEl = document.getElementById('gallery-count');

    if (!stage || !thumbsContainer) return;

    const thumbs = thumbsContainer.querySelectorAll('.gallery__thumb');
    const slides = Array.from(thumbs).map(thumb => ({
      src: thumb.dataset.src,
      alt: thumb.dataset.alt || ''
    }));

    let currentIndex = 0;

    function goToSlide(index) {
      currentIndex = (index + slides.length) % slides.length;

      // Update main image
      const mainImg = stage.querySelector('img');
      if (mainImg) {
        mainImg.src = slides[currentIndex].src;
        mainImg.alt = slides[currentIndex].alt;
      }

      // Update counter
      if (countEl) {
        countEl.textContent = (currentIndex + 1) + ' / ' + slides.length;
      }

      // Update active thumb
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === currentIndex);
      });

      // Scroll thumb into view
      const activeThumb = thumbs[currentIndex];
      if (activeThumb) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));
    }

    // Thumbnail clicks
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goToSlide(i));
    });

    // Touch swipe support
    let touchStartX = null;
    const stageEl = stage;

    stageEl.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    stageEl.addEventListener('touchend', function(e) {
      if (touchStartX === null) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        goToSlide(currentIndex + (dx < 0 ? 1 : -1));
      }
      touchStartX = null;
    }, { passive: true });

    // Initialize
    goToSlide(0);
  }

  // ============================================
  // PRODUCT VARIANT / TIER SELECTION
  // ============================================
  function initTierSelection() {
    const tierRows = document.querySelectorAll('.tier-row');
    const atcBtn = document.getElementById('atc-btn');
    const stickyAtc = document.getElementById('sticky-atc');
    const stickyPrice = document.getElementById('sticky-price');
    const closingAtc = document.getElementById('closing-atc');

    if (!tierRows.length) return;

    // Liquid-serialized map of all Bundle × Color variants
    const variantMapEl = document.getElementById('variant-map');
    const variants = variantMapEl ? JSON.parse(variantMapEl.textContent) : [];

    function resolveVariant() {
      const row = document.querySelector('.tier-row.selected');
      if (!row) return;

      const bundle = row.dataset.label;
      const colorInput = document.querySelector('.color-swatch__input:checked');
      const color = colorInput ? colorInput.value : null;

      const variant =
        variants.find(function(v) { return v.option1 === bundle && v.option2 === color; }) ||
        variants.find(function(v) { return v.option1 === bundle; });
      if (!variant) return;

      const price = '$' + (variant.price / 100).toFixed(2);
      const btnText = variant.available ? 'Get My ' + bundle + ' — ' + price : 'Sold out';

      // Update ATC buttons + selected variant id
      [atcBtn, stickyAtc, closingAtc].forEach(function(btn) {
        if (btn) btn.dataset.variantId = variant.id;
      });
      if (atcBtn) {
        atcBtn.textContent = btnText;
        atcBtn.disabled = !variant.available;
      }
      if (closingAtc) closingAtc.textContent = btnText;
      if (stickyPrice) stickyPrice.textContent = price;
    }

    function selectTier(tierValue) {
      tierRows.forEach(function(row) {
        const isSelected = row.dataset.tier === tierValue;
        row.classList.toggle('selected', isSelected);
        const radio = row.querySelector('input[type="radio"]');
        if (radio) radio.checked = isSelected;
      });
      resolveVariant();
    }

    // Click/change handlers
    tierRows.forEach(function(row) {
      row.addEventListener('click', function() {
        selectTier(row.dataset.tier);
      });

      const radio = row.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function() {
          selectTier(row.dataset.tier);
        });
      }
    });

    // URL parameter deep link
    const urlParams = new URLSearchParams(window.location.search);
    const tierParam = urlParams.get('tier');
    const validTiers = Array.from(tierRows).map(r => r.dataset.tier);
    selectTier(validTiers.includes(tierParam) ? tierParam : '2');

    // Re-resolve the variant whenever the color swatch changes
    document.querySelectorAll('.color-swatch__input').forEach(function(input) {
      input.addEventListener('change', resolveVariant);
    });
  }

  // ============================================
  // COLOR SWATCH SELECTION
  // ============================================
  function initColorSwatches() {
    const swatchInputs = document.querySelectorAll('.color-swatch__input');
    const swatchLabels = document.querySelectorAll('.color-swatch');
    const colorName = document.getElementById('color-name');
    const stageImg = document.querySelector('#gallery-stage img');

    if (!swatchInputs.length) return;

    swatchInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        // Update active state
        swatchLabels.forEach(s => s.classList.remove('active'));
        const label = document.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('active');

        // Update color name
        if (colorName) {
          colorName.textContent = input.dataset.color;
        }

        // Update main image
        if (stageImg && input.dataset.img) {
          stageImg.src = input.dataset.img;
          stageImg.alt = 'Lavabolife exfoliating bath gloves - ' + input.dataset.color;
        }
      });
    });
  }

  // ============================================
  // STICKY MOBILE BAR
  // ============================================
  function initStickyBar() {
    const bar = document.getElementById('sticky-bar');
    if (!bar) return;

    let scrollThreshold = 560;
    const pdp = document.querySelector('.pdp');
    if (pdp) {
      scrollThreshold = 620;
    }

    function updateStickyBar() {
      if (window.innerWidth <= 760) {
        bar.classList.toggle('show', window.scrollY > scrollThreshold);
      } else {
        bar.classList.remove('show');
      }
    }

    window.addEventListener('scroll', updateStickyBar, { passive: true });
    window.addEventListener('resize', updateStickyBar, { passive: true });
  }

  // ============================================
  // ADD TO CART
  // ============================================
  function initAddToCart() {
    const atcButtons = document.querySelectorAll('[data-add-to-cart]');

    atcButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();

        const variantId = btn.dataset.variantId;
        const quantity = btn.dataset.quantity || 1;

        if (!variantId) {
          console.warn('No variant ID specified');
          return;
        }

        // Show loading state
        const originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        // Add to cart via Shopify AJAX API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: parseInt(quantity)
          })
        })
        .then(response => response.json())
        .then(data => {
          btn.textContent = 'Added!';

          // Update cart count
          updateCartCount();

          // Open cart drawer if exists
          const drawer = document.getElementById('cart-drawer');
          if (drawer) {
            openCartDrawer();
          }

          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          btn.textContent = 'Error';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
      });
    });
  }

  // ============================================
  // CART DRAWER
  // ============================================
  function initCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    const closeBtn = document.querySelector('.cart-drawer__close');
    const cartLinks = document.querySelectorAll('[data-cart-toggle]');

    if (!drawer) return;

    function openCartDrawer() {
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeCartDrawer() {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    cartLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
        refreshCartDrawer();
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeCartDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeCartDrawer);
    }

    // Expose globally for ATC
    window.openCartDrawer = openCartDrawer;
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderCartDrawer(cart);
      });
  }

  function renderCartDrawer(cart) {
    const body = document.querySelector('.cart-drawer__body');
    const freeShipBar = document.querySelector('.free-shipping-bar');

    if (!body) return;

    // Update free shipping progress
    if (freeShipBar) {
      const threshold = (parseInt(freeShipBar.dataset.threshold) || 25) - 0.01; // $24.99 Duo must qualify
      const total = cart.total_price / 100;
      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, (total / threshold) * 100);

      const progressBar = freeShipBar.querySelector('.free-shipping-bar__progress');
      const text = freeShipBar.querySelector('.free-shipping-bar__text');

      if (progressBar) progressBar.style.width = progress + '%';
      if (text) {
        if (remaining > 0) {
          text.textContent = '$' + remaining.toFixed(2) + ' away from free shipping!';
        } else {
          text.textContent = 'You qualify for free shipping!';
        }
      }
    }

    // Render cart items
    if (cart.items.length === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
      return;
    }

    let html = '';
    cart.items.forEach(item => {
      html += `
        <div class="cart-item" data-key="${item.key}">
          <img src="${item.image}" alt="${item.title}" class="cart-item__image">
          <div class="cart-item__details">
            <h4 class="cart-item__title">${item.product_title}</h4>
            <p class="cart-item__variant">${item.variant_title || ''}</p>
            <p class="cart-item__price">$${(item.final_line_price / 100).toFixed(2)}</p>
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" data-change="-1">-</button>
              <span>${item.quantity}</span>
              <button class="cart-item__qty-btn" data-change="1">+</button>
            </div>
          </div>
          <button class="cart-item__remove" data-remove>&times;</button>
        </div>
      `;
    });

    body.innerHTML = html;

    // Bind quantity/remove handlers
    body.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const item = btn.closest('.cart-item');
        const key = item.dataset.key;
        const change = parseInt(btn.dataset.change);
        const currentQty = parseInt(item.querySelector('.cart-item__qty span').textContent);
        updateCartItem(key, currentQty + change);
      });
    });

    body.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const item = btn.closest('.cart-item');
        updateCartItem(item.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(response => response.json())
    .then(cart => {
      renderCartDrawer(cart);
      updateCartCount();
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }

  // ============================================
  // FAQ ACCORDIONS
  // ============================================
  function initFaqAccordions() {
    // Native <details> elements handle this automatically
    // This is here for any custom accordion behavior if needed
  }

  // ============================================
  // DYNAMIC YEAR
  // ============================================
  function initDynamicYear() {
    const yearEls = document.querySelectorAll('[data-year]');
    const year = new Date().getFullYear();
    yearEls.forEach(el => {
      el.textContent = year;
    });
  }

  // ============================================
  // LAZY LOADING (native + polyfill fallback)
  // ============================================
  function initLazyLoading() {
    if ('loading' in HTMLImageElement.prototype) {
      // Native lazy loading supported
      return;
    }

    // Fallback for older browsers
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src || img.src;
            observer.unobserve(img);
          }
        });
      });

      lazyImages.forEach(function(img) {
        observer.observe(img);
      });
    }
  }

  // ============================================
  // INITIALIZE ALL
  // ============================================
  function init() {
    initMobileNav();
    initAnnouncementBar();
    initGallery();
    initTierSelection();
    initColorSwatches();
    initStickyBar();
    initAddToCart();
    initCartDrawer();
    initFaqAccordions();
    initDynamicYear();
    initLazyLoading();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
